{
  "create_schedule_title": "Create schedule",
  "present_schedule_title": "Present",
  "create_new": "Create new",
  "event_code": "Event code",
  "no_event_found": "No schedule was found for the given code",
  "created_by_sammandrag_se": "Created by sammandrag.se: <a href=\"{{baseUrl}}/{{code}}\">{{baseUrl}}/{{code}}</a>",
  "view_count": "Views: {{count}}",
  "cancel": "Cancel",
  "ok": "Ok",
  "view": "View",
  "show_event_info": "Show event info",
  "hide_event_info": "hide event info",
  "no_previous_schedule": "You have no existing schedule to start from and want to create a new schedule.",
  "create_login_desc": "Log in to access and edit your saved events",
  "copy": "Copy",
  "copy_settings": "Copy settings from an existing schedule. You can modify these settings later",
  "copy_schedule_not_found": "No schedule was found for the provided schedule code.",
  "copy_schedule_failed": "Something went wrong while copying. Please try again.",
  "schedule_code": "Schedule code",
  "next": "Next",
  "previous": "Previous",
  "add_text_row_title": "Add text row",
  "schedule_is_updated": "Your schedule is updated!",
  "schedule_name_required": "Please enter a name for the schedule.",
  "present_schedule": "Present schedule",
  "event_saved": "Congratulations, your event is ready!",
  "unsaved_changes": "Unsaved changes",
  "group_in_use": "Group is referenced by a schedule",
  "venue_in_use": "Venue is referenced by a schedule",
  "done_email_info": "Share the direct link or event code with your participants.",
  "event_code_with_code": "Event code: {{eventCode}}",
  "direct_link": "Direct link:",
  "registration_link": "Registration link:",
  "event_visibility": "Visibility",
  "event_visibility_public": "Public",
  "event_visibility_private": "Private",
  "event_visibility_help": "Public events are shown on the map (if a location is set) and can be found there. Private events are hidden from the map and search.",
  "sport": "Sport",
  "sport_not_set": "Not set",
  "sport_soccer": "Soccer",
  "sport_basketball": "Basketball",
  "sport_field_hockey": "Field hockey",
  "sport_ice_hockey": "Ice hockey",
  "sport_floorball": "Floorball",
  "sport_handball": "Handball",
  "sport_volleyball": "Volleyball",
  "sport_rugby": "Rugby",
  "sport_cricket": "Cricket",
  "sport_baseball": "Baseball",
  "sport_softball": "Softball",
  "sport_american_football": "American football",
  "sport_badminton": "Badminton",
  "sport_tennis": "Tennis",
  "sport_table_tennis": "Table tennis",
  "sport_beach_volleyball": "Beach volleyball",
  "sport_other": "Other",
  "sport_other_placeholder": "Enter sport",
  "sport_filter_all": "All sports",
  "email": "E-mail",
  "back": "Back",
  "preview": "Preview",
  "enter_email": "Enter your email",
  "why_email_info": "The event is connected to your email so it can be edited later",
  "event_info": "Event Info",
  "no_event_info": "Click Edit to fill in event information",
  "email_required": "An e-mail address are required",
  "schedule_overwrite_warning": "Your saved schedule will be overwritten! The new schedule will keep the same schedule code. This action cannot be undone",
  "message_sent": "Your message has been submitted!",
  "field_count": "Fields",
  "period_count": "Periods",
  "period_length": "Period duration",
  "period_pause": "Period pause",
  "game_pause": "Pause between matches",
  "field_count_adjust_info": "The current field count requires at least {{minTeamCount}} teams or it will adjusted automatically .",
  "game_format": "Game format",
  "start_time": "Start time",
  "no_teams_added": "No teams added",
  "team_association_count": "Teams: {{teamCount}}, Associations {{associationCount}}",
  "association_team": "Association/Team",
  "suffix": "Suffix",
  "team_suffix_placeholder": "Eg. 1, 2, Red, Girls 18",
  "game_count": "Game count",
  "game_count_default": "As per game format",
  "max_team_count_info": "A maximun of 120 teams are allowed. If you have more teams, try dived them into separate schedules.",
  "min_association_count_info": "At least two associations are required",
  "add": "Add",
  "update": "Update",
  "games_per_team": "Number of matches per team",
  "team_count": "Team count",
  "association": "Association",
  "attending_teams": "Participating teams",
  "remove": "Remove",
  "delete_association": "Remove association",
  "delete_single_team": "Remove single team",
  "duplicate_suffix_error": "Team names within the same association are not unique – change the name to avoid name conflicts.",
  "generate_schedule": "Generate schedule",
  "generating_schedule_spinner": "Generating schedule, it may take a few seconds...",
  "no_schedule_found": "No schedule was found with the given settings.",
  "game_schedule": "Schedule",
  "move_schedule_up": "Move up",
  "move_schedule_down": "Move down",
  "your_association": "Your association's name",
  "date": "Date",
  "location": "Location",
  "other": "Other info",
  "association_placeholder": "My Club",
  "location_placeholder": "Address or directions",
  "other_placeholder": "Other info, E.g. Is the kiosk open?",
  "when": "{{date, localDateFormat}}",
  "when_range": "{{start, localDateFormat}} - {{end, localDateFormat}}",
  "shedule_present_title": "Welcome to {{association}}",
  "text": "Text",
  "position": "Position",
  "duration": "Duration",
  "time": "Time",
  "interval": "Round",
  "games": "Matches",
  "custom_row_text_placeholder": "E.g. Lunchbreak",
  "penalty_no_remarks": "The schedule has no remarks",
  "penalty_is_not_valid": "The schedule contains invalid matches",
  "penalty_has_removed_teams": "The schedule contains matches with deleted teams",
  "mutual_meeting_title": "Mutual meetings",
  "mutual_meeting_content": "Mutual meetings between same association could not be avoided with the given setup.",
  "penalty_same_associations": "{{sameAssociationAsOpponentCount}} matches between same association!",
  "penalty_same_opponents": "{{sameOpponentCount}} teams meets the same opponent more than once!",
  "penalty_same_opponent_association": "{{sameOpponentAssociationCount}} team(s) meets the same association more than once",
  "penalty_own_association": "{{ownAssociationCount}} mutual meetings within the same association!",
  "penalty_adjacent_intervals": "{{adjacentIntervalCount}} occurrences of teams with back-to-back matches!",
  "penalty_extra_intervals": "The schedule has {{extraIntervals}} extra round(s)",
  "penalty_reminder": "{{reminderTeam}} plays one extra game due to the give setup",
  "adjacent_games": "Back-to-back matches",
  "adjacent_games_info": "Back-to-back matches cannot be avoided for some setups without creating extra rounds. Allowing both back-to-back matches and extra rounds gives a good compromise.",
  "extra_intervals": "Extra rounds",
  "extra_intervals_info": "Extra rounds might be necessary for setups with many fields and few associations. Allowing back-to-back matches can decrease the number of extra rounds needed.",
  "extra_game": "Extra match",
  "extra_game_info": "The given setup requires one team to play an extra match. You can control which team by increasing the number of matches for the desired team in previous steps",
  "opponent": "Opponents",
  "field_name": "Field {{fieldNumber}}",
  "add_team": "Add team",
  "duplicate_association_name": "Name already in use",
  "duplicate_team_name": "Team name conflict",
  "duplicate_team_name_error": "A team name is identical to another team's name (association name plus team name). Change the association or team name.",
  "remove_row": "Remove row",
  "add_row": "Add row",
  "drag_here_to_remove_from_schedule": "Drag and drop here to remove a team from the schedule",
  "edit_play_order": "Edit play order",
  "mobile_schedule_select_hint": "Tap a team in the schedule, or a removed team chip below, to select it",
  "mobile_schedule_swap_hint": "Tap another slot to swap, or tap the same slot again to deselect",
  "mobile_removed_team_selected_hint": "Tap a slot in the schedule to place the team there",
  "mobile_no_removed_teams": "No teams are waiting outside the schedule",
  "mobile_removed_teams_hint": "Tap a removed team to place it in the selected free slot",
  "mobile_remove_team_or_swap_hint": "Tap \"Remove from schedule\" to remove the selected team, or tap a removed team to swap",
  "mobile_remove_from_schedule": "Remove from schedule",
  "schedule_game_format": "Game format: {{periods}} x {{periodLength}} minutes",
  "schedule_schedule_code": ", schedule code {{scheduleCode}}",
  "team": "Team",
  "free": "Free",
  "allow_adjacent_games": "Teams are allowed to have back-to-back matches",
  "allow_adjacent_games_help_title": "Allow back-to-back matches",
  "allow_adjacent_games_help_content": "Back-to-back matches will be avoided if possible but might be necessary for some setups to prevent too many extra rounds.",
  "max_extra_rounds": "Extra rounds",
  "max_extra_rounds_auto": "Auto (recommended)",
  "max_extra_rounds_none": "None",
  "max_extra_rounds_option": "Max {{count}}",
  "allow_extra_intervals_help_content": "Extra rounds are rounds where the schedule has free slots. They may be necessary in setups with many fields and few teams, or to reduce the number of back-to-back matches. Auto picks a suitable limit for your setup, or choose the maximum number of extra rounds allowed.",
  "manual_edit_info_title": "Did you know that it's now possible to edit your schedule manually: Read more here",
  "edit_schedule_help_title": "Manage schedule",
  "edit_schedule_help_content": "You can edit the play order on both computers and mobile devices. Press the edit icon at the top of the schedule, click a team to select it, then click the slot you want to move it to. Add an extra round with the + button on the last row. Add extra matches for a team by pressing \"Add team\", then click the team and click the desired slot in the schedule.",
  "terms_and_conditions": "<h4>Villkor och ansvar</h4> <p>Tjänsten tillhandahålls utan kostnad. Används annan presentation än via sammandrag.se (t.ex. genom egna utskrifter eller egna utskick) skall det tydligt framgå att spelschemat är skapat via sammandrag.se. Sammandrag.se kan inte garantera oavbruten tillgång till tjänsten då webbplatsen kan komma att störas av faktorer utanför vår kontroll och vi ställer inga garantier gällande webbplatsens funktion eller tillgänglighet. Sammandrag.se kan inte göras ansvarigt för skador som direkt eller indirekt orsakas av användning av webbplatsen och dess innehåll.</p><h3>Integritetspolicy</h3><p>Vi tar din integritet på stort allvar. Din e-post adress sparas tillsammans med spelschemat du skapat för att ge möjligheten att redigera spelschemat. Vi kommer inte använda uppgifterna i annat syfte än vad som är nödvändigt för tjänstens funktion.</p>",
  "accept_conditions": "By completing the schedule you accept the terms and conditions. To read them click ",
  "accept_conditions_link_text": "here",
  "finish": "Finish",
  "schedule_code_placeholder": "ABC123",
  "association_name_placeholder": "Association name",
  "generate_schedule_title": "You can generate multiple schedules and compare them. Select the one you prefer by clicking the schedule's title bar",
  "before_interval_one": "Before round 1",
  "after_interval": "After round",
  "location_with_params": "{{location}}",
  "organizer_with_params": "{{organizer}}",
  "get": "Go",
  "save_schedule_exists_info": "A new schedule was created due to your changes. You find the original schedule at the end of the page if you rather apply the changes manually",
  "nav_create": "Create",
  "nav_edit": "Edit",
  "nav_present": "Present",
  "nav_about": "About",
  "about_the_service_header": "About the service",
  "contact_us_title": "Contact us",
  "contact_us_content": "Have ideas, request, issues or other resons to contact us? Please fill in the form below",
  "message_title": "Message",
  "message_placeholder": "Your message",
  "send": "Send",
  "field": "Field",
  "start_date": "Start date",
  "end_date": "End date",
  "description": "Description",
  "review_schedule_header": "Review schedule",
  "create_single_schedule_title": "Create a new event with a single match schedule",
  "create_multiple_schedules_title": "Create a new event with multiple match schedules",
  "schedule_name": "Name",
  "schedule_name_placeholder": "Schedule name",
  "schedule_description": "Description",
  "schedule_description_placeholder": "Group Stage",
  "schedule_description_help_title": "Schedule description",
  "schedule_description_help_content": "If you have multiple schedules for the same class, add a description so you can tell them apart. For example, Group Stage or Final",
  "day": "Day",
  "title": "Title",
  "event_title_placeholder": "Welcome to the girls' tournament in Div 5",
  "event_description_placeholder": "The kiosk is open. Welcome!",
  "organizer": "Organizer",
  "event_summary_title": "Overview",
  "add_schedule": "Add match schedule",
  "game_schedules": "Match schedules",
  "no_schedules_added": "No match schedules added",
  "all": "All",
  "name": "Name",
  "group": "Class",
  "group_name_placeholder": "e.g. U17 Girls / U15 Boys",
  "visibility": "Visibility",
  "manage_groups": "Manage classes",
  "manage_venues": "Manage venues",
  "add_venue": "Add venue",
  "venue_name": "Name",
  "venue_name_placeholder": "e.g. Artificial grass",
  "no_venues_added": "No venues added",
  "delete_venue": "Delete venue",
  "save": "Save",
  "nav_login": "Log in",
  "nav_logout": "Log out",
  "nav_my_events": "My events",
  "nav_invites": "Invites",
  "shared_event": "Shared",
  "share_accept": "Accept",
  "share_decline": "Decline",
  "share_leave": "Leave",
  "participant_event": "Participating",
  "participant_registration": "Go to registration",
  "participant_leave": "Leave association",
  "pending_invites_message": "You have {{count}} pending invites.",
  "pending_invites_link": "View",
  "invites_back_to_my_events": "Back to my events",
  "invites_none_found": "You have no pending invites.",
  "registration_revoke": "Revoke registration",
  "registration_revoke_confirmation": "Revoke the registration. All teams and members of the association will be removed. Are you sure? This can't be undone",
  "edit_event_registration_enable": "Enable public registration",
  "edit_event_registration_help_title": "Public registration",
  "edit_event_registration_help_content": "Public registration enables a sign-up form where participants can register their own teams and enter contact details. The information can then be adjusted before you create your game schedule",
  "edit_event_registration_closes": "Registration closes",
  "registration_heading": "Registration",
  "registration_event_not_found": "There is no event with that code.",
  "registration_organizer_label": "Organizer:",
  "registration_date_label": "Date:",
  "registration_location_label": "Location:",
  "registration_location_not_specified": "Not specified",
  "registration_no_description": "No description",
  "registration_closed_message": "Registration has closed and can no longer be changed. Contact the organizer if you need help.",
  "registration_not_open_message": "Registration is not open for this event.",
  "registration_invited_as": "You have been invited as {{role}} to this team.",
  "registration_accept_invite": "Accept invite",
  "registration_add_team": "Add team",
  "registration_no_teams_registered": "No teams registered.",
  "registration_members_heading": "Contacts",
  "edit_teams_contacts_help_content": "Add contacts to make it easy to get in touch later. No email or other message is sent, but if the user is logged in, the event will be shown to them with the participant permission",
  "add_contact_person": "Add contact",
  "no_contacts_added": "No contacts added",
  "registration_member_pending": "Pending",
  "registration_invite_button": "Add",
  "contact_email_placeholder": "coach@example.com",
  "role_manager": "Administrator",
  "role_contact": "Contact",
  "registration_closed_contact_organizer": "Registration is closed. All changes must go through the organizer.",
  "registration_available_groups_heading": "Available groups",
  "registration_new_title": "Register team",
  "registration_login_prompt": "Log in to create a team and submit the registration.",
  "registration_new_title_with_group": "Register team – {{group}}",
  "registration_save": "Save registration",
  "registration_group_fallback": "Group",
  "registration_validation_message": "Specify a group, association name and at least one team.",
  "registration_save_failed": "The registration could not be saved.",
  "registration_save_success": "Your registration has been submitted.",
  "registration_cannot_leave_last_manager": "You are the only accepted manager and cannot leave the association/team.",
  "login_title": "Log in",
  "login_with_microsoft": "Continue with Microsoft",
  "login_with_google": "Continue with Google",
  "login_with_apple": "Continue with Apple",
  "no_events_found": "You have no saved events.",
  "orphan_event": "Remove from my events",
  "orphan_event_confirmation": "Delete event. Are you sure? This can't be undone",
  "my_events_toggle_advanced_tools": "Import events",
  "edit": "Edit",
  "share": "Share",
  "share_whatsapp": "Share on WhatsApp",
  "share_facebook": "Share on Facebook",
  "copy_link": "Copy link",
  "teams": "Teams",
  "manage_teams": "Manage teams",
  "no_groups_added": "No groups added",
  "team_count_label": "Teams",
  "team_count_for_association": "Number of teams in this association",
  "team_count_for_association_help": "Applies only to the association you are adding now. The total number of teams in this class is shown below.",
  "add_team_association_label": "Association name",
  "add_team_count_label": "Number of teams from this association",
  "add_team_count_help": "How many teams from this association are participating in the class.",
  "team_count_total_in_group": "Total teams in this class: {{count}}",
  "team_count_total_after_add": "After Add: {{count}}",
  "team_totals_for_group": "Total in {{groupName}}: Associations {{associationCount}}, Teams {{teamCount}}",
  "association_team_count": "{{count}} teams",
  "expand": "Show more",
  "collapse": "Show less",
  "select_group": "Select group",
  "serie_group_section_title": "Class selection for this schedule",
  "serie_group_help": "Select classes. A combined schedule helps you optimize venue allocation and simplify scheduling for multiple classes at the same time.",
  "serie_group_selected_count": "Selected classes: {{count}}",
  "new_group": "New group",
  "group_filter": "Filter by group",
  "all_groups": "All groups",
  "team_distribution_strategy": "Team distribution",
  "team_distribution_strategy_optimized": "Optimized (recommended)",
  "team_distribution_strategy_distributed": "Distributed",
  "team_distribution_strategy_help_title": "Team distribution",
  "team_distribution_strategy_help_content": "Optimized keeps each class's total time as short as possible and fills the remaining slots with other classes. Distributed spreads all teams evenly over the whole schedule, which can make each class last longer.",
  "nav_map": "Map",
  "geocode_search": "Search",
  "geocode_clear": "Clear coordinates",
  "geocode_not_found": "Address not found. Try a different spelling.",
  "geocode_hint": "Click the map to place a pin or drag it to the desired location.",
  "open_maps": "Open in maps",
  "map_from_date": "From date",
  "map_to_date": "To date",
  "map_search_label": "Organizer/address",
  "map_search_placeholder": "Search organizer or address",
  "map_search": "Search",
  "map_event_count": "{{count}} events shown",
  "map_load_error": "Could not load events. Please try again.",
  "event_comments_header": "Messages",
  "event_comment_placeholder": "Enter a message",
  "event_comments_help_content": "Create short messages that are shown immediately on the event page. They can also be edited or removed afterwards.",
  "event_comment_add": "Add",
  "event_no_comments": "No messages added",
  "event_comments_show_more": "Show more...",
  "event_comments_show_less": "Show fewer",
  "passkey_register": "Register with passkey",
  "passkey_sign_in": "Sign in with passkey",
  "passkey_not_supported": "Your browser does not support passkeys",
  "passkey_registering": "Registering...",
  "passkey_signing_in": "Signing in...",
  "passkey_not_registered": "No passkey is registered for this email address. Click \"Register with passkey\" to create one.",
  "login_continue": "Continue",
  "login_checking": "Checking...",
  "login_methods_for": "Sign-in methods for",
  "login_back": "← Back",
  "login_provider_mismatch": "An account with this email address already exists, registered with a different sign-in method. Please use the method you used when creating your account.",
  "login_email_label": "Sign in with email",
  "email_code_send": "Send email code",
  "email_code_sending": "Sending code...",
  "email_code_sent": "Enter the code",
  "email_code_check_email": "We sent a 6-digit code to {{email}}. Enter it below to sign in.",
  "email_code_label": "6-digit code",
  "email_code_verify": "Verify code",
  "email_code_verifying": "Verifying...",
  "email_code_invalid": "The code is incorrect or has expired. Check the code and try again, or request a new code.",
  "login_too_many_requests": "Too many attempts. Please wait a while and try again.",
  "too_many_requests": "Too many requests. Please wait a while and try again.",
  "login_or": "Or",
  "login_social_header": "Sign in with social account",
  "login_passkey_header": "Sign in with passkey",
  "login_magic_header": "Sign in with email link",
  "share_event": "Share",
  "share_event_title": "Share event",
  "share_add": "Add",
  "share_email": "Email address",
  "share_permission_can_edit": "Can edit",
  "share_revoke": "Revoke",
  "share_pending": "Waiting for acceptance",
  "share_add_success": "Access granted",
  "share_add_error": "Could not grant access",
  "share_can_edit_info": "People you share with will be able to edit the event.",
  "share_send_info_title": "Send information by email",
  "share_send_invitation": "Send",
  "share_send_invitation_hint": "Create an invitation that can be forwarded to participating teams. Sent to your email.",
  "share_send_registration": "Send",
  "share_send_registration_hint": "Create registration information that can be forwarded to teams for registration. Sent to your email.",
  "share_invitation_sent": "Invitation information has been sent to your email.",
  "share_invitation_error": "Could not send invitation information.",
  "share_registration_sent": "Registration information has been sent to your email.",
  "share_registration_error": "Could not send registration information.",
  "import_event_title": "Import event",
  "import_event_desc": "Enter the event code and PIN from your older events to import them into your events.",
  "import_event_code_label": "Event code",
  "import_event_pin_label": "PIN (from old edit link)",
  "import_event_pin_short": "PIN",
  "import_event_button": "Claim event",
  "import_event_owned_by_other": "This event is already owned by another user.",
  "import_event_invalid_pin": "Incorrect PIN. Check your old edit link.",
  "import_event_not_found": "No event found with that code.",
  "import_event_success": "Event claimed successfully!",
  "save_requires_login": "You need to be logged in to save the event.",
  "click_here_to_login": "Click here to log in",
  "account_title": "My account",
  "account_section_profile": "Profile",
  "account_email_label": "Email address",
  "account_section_consents": "Consents",
  "account_email_consent_label": "I want to receive news and information from sammandrag.se",
  "account_email_consent_info": "You can change this consent at any time.",
  "account_cookie_settings_button": "Manage cookie settings",
  "account_section_language": "Language",
  "account_language_info": "Choose the language for the app.",
  "account_logout_button": "Log out",
  "account_section_danger": "Danger zone",
  "account_delete_info": "Deleting your account removes all your personal data. This cannot be undone.",
  "account_delete_button": "Delete my account",
  "account_delete_confirm_prompt": "Are you sure? This cannot be undone.",
  "account_delete_confirm_button": "Yes, delete",
  "account_section_passkeys": "Passkeys",
  "account_section_providers": "Sign-in methods",
  "account_provider_linked": "Connected",
  "account_provider_link": "Add",
  "account_passkey_info": "Register a passkey on your device for passwordless sign-in.",
  "account_passkey_register_button": "Register passkey",
  "account_passkey_registered": "Passkey registered! You can now sign in with this device.",
  "account_passkey_registered_badge": "Registered passkeys: {{count}}",
  "onboarding_title": "Welcome to sammandrag.se",
  "onboarding_intro": "Please read and accept the terms to continue.",
  "onboarding_accept_terms_prefix": "I have read and accept the",
  "onboarding_terms_link": "terms of service",
  "onboarding_and": "and",
  "onboarding_privacy_link": "privacy policy",
  "onboarding_email_consent_optional": "Optional. You can change this at any time under My account.",
  "onboarding_continue": "Continue"
}
